<template>
  <v-container fluid tag="section">
    <base-material-card
      color="success"
      inline
      title="Edit User"
      class="px-12 py-1 mx-auto"
    >
      <formulate-form @submit="update" name="updateForm" :form-errors="formErrors"
    :errors="inputErrors" >
        <v-row class="space-evenly">
          <v-col cols="12" md="3">
            <formulate-input
              v-model="userData.email"
              type="email"
              name="email"
              label="Email"
              placeholder="Email"
              validation="required|email"
              error-behavior="blur"
            />
            <formulate-input
              id="services"
              v-model="selectedServices"
              :options="services"
              type="checkbox"
              label="Select your services"
              for="services"
            />
            <formulate-input
              v-model="userData.allowManual"
              :options="{ true: 'Yes', false: 'No' }"
              type="radio"
              for="allowManual"
              label="Do you want to allow Manual Booking ?"
            />
          </v-col>
          <v-col cols="12" md="3">
            <formulate-input
              v-model="selectedProvider"
              disabled
              type="radio"
              label="Select your provider"
              name="selectedProvider"
              :options="{ autocab: 'Autocab', infocab: 'Infocab' }"
              for="selectedProvider"
              :element-class="(context, classes) => ['disabled-class'].concat(classes)"
            />

            <formulate-form  v-if="selectedProvider === 'autocab'" @submit="fetchCompanies">
              <formulate-input
                v-model="userData.api_username"
                type="text"
                name="api_username"
                label="API Username"
                placeholder="Enter API username"
                validation="required"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.api_password"
                type="text"
                name="api_password"
                label="API Password"
                placeholder="Enter API password"
                validation="required"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.api_host"
                type="url"
                name="api_host"
                label="API Host"
                placeholder="Enter API Host Url"
                validation="required"
                error-behavior="blur"
              />
              <formulate-input
                type="submit"
                :disabled="disableFetchButton"
                name="Fetch Companies"
              />
            </formulate-form>


            <formulate-form v-else-if="selectedProvider === 'infocab'" @submit="fetchInfoCompanies">
                <formulate-input
                  v-model="userData.infocab_host"
                  type="url"
                  name="infocab_host"
                  label="Infocab host"
                  placeholder="Enter infocab host"
                  validation="required"
                  error-behavior="blur"
                />
                <formulate-input
                  v-model="userData.infocab_token"
                  type="text"
                  name="infocab_token"
                  label="Infocab Token"
                  placeholder="Enter Infocab Token"
                  validation="requiredIfInfocab"
                  error-behavior="blur"
                />
                <formulate-input
                  type="submit"
                  :disabled="disableInfoFetchButton"
                  name="Fetch Companies"
                />
              </formulate-form>

            <formulate-input
              v-show="companies.length"
              v-model="selectedCompanies"
              class="mt-7"
              :options="companies"
              type="checkbox"
              label="Select Companies"
              for="companies"
              validation="required|min:1"
            />

            <div v-for="sc in selectedCompanies" :key="sc">
              <formulate-input type="button" @click="setJudoAccount(sc)">
                {{ selectTitleForJudoButton(sc) }} Judo for {{ sc }}
              </formulate-input>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <formulate-input
              v-model="userData.sms_service"
              type="radio"
              label="Select your SMS method"
              name="payment"
              :options="{ twillio: 'Twillio', whatsApp: 'WhatsApp/URL' }"
              for="sms"
              :element-class="
                (context, classes) =>
                  ['sms-gateway-element-class'].concat(classes)
              "
            />

            <formulate-input
              v-show="userData.sms_service == 'twillio'"
              type="group"
            >
              <formulate-input
                v-model="userData.twillio.sid"
                type="text"
                name="twillio_sid"
                label="Twillio SID"
                placeholder="Twillio SID"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(
                      userData.twillio.sid == '' &&
                      userData.sms_service == 'twillio'
                    ),
                }"
                :validation-messages="{
                  twillio_validation: 'SID is required.',
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.twillio.auth"
                type="text"
                name="twillio_auth"
                label="Twillio Auth Token"
                placeholder="Twillio Auth Token"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(
                      userData.twillio.auth == '' &&
                      userData.sms_service == 'twillio'
                    ),
                }"
                :validation-messages="{
                  twillio_validation: 'Auth token is required.',
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.twillio.number"
                type="text"
                name="twillio_number"
                label="Twillio Number"
                placeholder="Twillio Number"
                validation="twillio_validation"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(
                      userData.twillio.number == '' &&
                      userData.sms_service == 'twillio'
                    ),
                }"
                :validation-messages="{
                  twillio_validation: 'Number is required.',
                }"
                error-behavior="blur"
              />
            </formulate-input>
            <formulate-input
              v-show="userData.sms_service == 'whatsApp'"
              type="group"
            >
              <formulate-input
                v-model="userData.whatsApp.link"
                name="link"
                label="Url link"
                placeholder="Enter Url link"
                validation="twillio_validation"
                :validation-messages="{
                  twillio_validation: 'URL link is required.',
                }"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(
                      userData.whatsApp.link == '' &&
                      userData.sms_service == 'whatsApp'
                    ),
                }"
                error-behavior="blur"
              />
              <formulate-input
                v-model="userData.whatsApp.password"
                type="text"
                name="password"
                label="Url Link password"
                placeholder="Enter Url password"
                validation="twillio_validation"
                :validation-messages="{
                  twillio_validation: 'URL link password is required.',
                }"
                :validation-rules="{
                  twillio_validation: ({ value }) =>
                    !(
                      userData.whatsApp.password == '' &&
                      userData.sms_service == 'whatsApp'
                    ),
                }"
                error-behavior="blur"
              />
            </formulate-input>

            <formulate-input type="submit" name="Update User" />
          </v-col>
        </v-row>
      </formulate-form>
    </base-material-card>
    <v-dialog v-model="dialog" max-width="800">
      <v-card class="text-center">
        <v-card-title>
          Add Judo Credentials for {{ current_judo.company }}

          <v-spacer />

          <v-icon aria-label="Close" @click="dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-12 py-1 mx-auto">
          <formulate-form
            :keep-model-data="true"
            v-model="current_judo"
            @submit="saveJudoCredentials"
            name="JudoCredentialsForm"
          >
            <v-row>
              <v-col cols="12" md="6">
                <formulate-input
                  type="text"
                  name="judo_id"
                  label="Judo ID"
                  placeholder="Enter Judo ID"

                />
                <formulate-input
                  type="text"
                  name="judo_auth_sandbox"
                  label="Judo Auth Sandbox"
                  placeholder="Enter Judo Auth Sandbox"

                />
              </v-col>
              <v-col cols="12" md="6">
                <formulate-input
                  type="url"
                  name="judo_sandbox_url"
                  label="Judo Sandbox Url"
                  placeholder="Enter Judo Sandbox Url"

                />
                <formulate-input
                  type="text"
                  name="judo_api_version"
                  label="Judo API version"
                  placeholder="Enter Judo API version"

                />

                <div class="flex">
                  <formulate-input type="submit" name="Save Credentials" :disabled="current_judo.judo_id=='' || current_judo.judo_sandbox_url=='' || current_judo.judo_auth_sandbox=='' || current_judo.judo_api_version==''" />
                  <formulate-input
                    v-if="editJudoCredentials"
                    @click="removeJudoCredentials(current_judo.company)"
                    type="button"
                    name="Remove Account"
                    :element-class="
                      (context, classes) => ['ml-10'].concat(classes)
                    "
                  />
                </div>
              </v-col>
            </v-row>
          </formulate-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <base-material-snackbar
      v-model="snackbar"
      type="error"
      v-bind="{
        bottom: true,
        right: true,
      }"
    >
      {{ snackbarText }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
import { _getCompanies, _getInfoCompanies, _show, _update, _getServices } from "@/services/User";
// import { defineRule } from '@braid/vue-formulate'

export default {
  name: "EditUser",
  data() {
    return {
    selectedProvider: 'autocab',

      formErrors: [],
      inputErrors: {},
      userData: {
        email: "",
        api_username: "",
        api_password: "",
        api_host: "",
        infocab_host: '',
        infocab_token: '',
        sms_service: "",
        twillio: {
          sid: "",
          auth: "",
          number: "",
        },
        whatsApp: {
          link: "",
          password: "",
        },
        allowManual: null,
      },
      companies: [],
      selectedCompanies: [],
      services: [],
      selectedServices: [],
      disableFetchButton: false,
    disableInfoFetchButton: false,

      editedIndex: "",
      apiError: "",
      snackbar: false,
      snackbarText: "",

      dialog: false,

      current_judo: {
        company: "",
        judo_id: "",
        judo_sandbox_url: "",
        judo_api_version: "",
        judo_auth_sandbox: "",
      },
      selectedCompaniesJudo: [],
      editJudoCredentials: false,
      serverSelectedJudoCompanies: [],
      theme: "blue-theme",


    };
 },
  mounted() {
    this.$formulate.extend({
      rules: {
        requiredIfInfocab: ({ value, getFormValues }) => {
          const provider = getFormValues().selectedProvider
          if (provider === 'infocab' && (!value || value.trim() === '')) {
            return 'Token is required for Infocab'
          }
          return true
        }
      }
    })
    this.getServices();
    this.editedIndex = this.$route.params.id;
    _show(this.editedIndex).then(
      (res) => {
        let localUser = res.data.obj.user;
        this.userData.api_username = localUser.api_username;
        this.userData.api_password = localUser.api_password;
        this.userData.api_host = localUser.api_host;
        this.userData.infocab_host = localUser.infocab_host;
        this.userData.infocab_token = localUser.infocab_token;
        this.selectedCompaniesJudo = localUser.judo_accounts.map(
          (j) => j.credentials
        );

        this.serverSelectedJudoCompanies =  JSON.parse(JSON.stringify(this.selectedCompaniesJudo));
        this.userData.email = localUser.email;
        this.userData.allowManual =
          localUser.allow_manual_booking  ? "true" : "false";

        this.selectedServices = localUser.services
          ? localUser.services.map((i) => i.id)
          : [];

          this.selectedProvider = localUser.provider;

        let sel = localUser.companies;
        this.companies = sel.map((v) => ({
          ...v,
          company_id: v.id,
          value: v.name,
          id: "id" + v.id,
          label: v.name,
        }));

        if (sel) {
          this.selectedCompanies = sel.map((v) => v.name);
        }
        this.userData.sms_service = localUser.smsgateway.type;
        if (localUser.smsgateway.type == "twillio") {
          this.userData.twillio = localUser.smsgateway.credentials;
        } else if (localUser.smsgateway.type == "whatsApp") {
          this.userData.whatsApp = localUser.smsgateway.credentials;
        }

      },
      (err) => {
         if (err.response && err.response.status) {
          switch (err.response.status) {
            case 422:
              this.inputErrors = err.response.data.errors // assign field errors
              this.formErrors = err.response.data.message
              return
            case 401:

              return
            // ... add lots more cases of bad things that can happen here
          }
        }
        else {
          alert('line 406')
        }

         this.disableFetchButton = false;
          this.snackbar = true;
          this.snackbarText = err.message;
        console.log(err.data);
      }
    ).catch((err) => {
          this.disableFetchButton = false;
          this.snackbar = true;
          this.snackbarText = err.message;
    });
  },

  watch: {
    selectedProvider(newProvider) {
      // this.companies = [];
      // this.selectedCompanies = [];
      // Emit event or perform logic based on selection
      console.log('Provider switched to:', newProvider)
      this.$emit('provider-changed', newProvider)
    },

    // selectedCompanies(newval) {
    //   this.selectedCompaniesJudo = this.selectedCompaniesJudo.filter((f) =>
    //     newval.includes(f.company)
    //   );
    // },

  },

  methods: {
    getServices() {
      _getServices().then((res) => {
        let objArray1 = res.data.obj;
        this.services = objArray1.map((v) => ({
          ...v,
          value: v.id,
          label: v.name,
        }));
      });
    },

    trimLeadingZeroFromPhone(phone){
      if (phone.startsWith("0")) {
        return phone.slice(1);
      }
      return phone;
    },
    fetchInfoCompanies() {
      this.disableInfoFetchButton = true;
      // this.companies = []
      // this.selectedCompanies = []
      let formData = {
        info_host: this.userData.infocab_host,
        info_token: this.userData.infocab_token,
      }
      _getInfoCompanies(formData)
        .then(
          (response) => {

            this.disableInfoFetchButton = false
            this.apiError = ''
            let data1 = response.data.obj.divisions
            let resCompanies1 = data1.map(function (d) {
              return {
                company_id: d.Id,
                api_company_id: d.Id,
                name: d.Name,
                label: d.Name,
                value: d.Name,
                latitude: (d.latitude !== undefined && d.latitude !== null) ? d.latitude : 0,
                longitude: (d.longitude !== undefined && d.longitude !== null) ? d.longitude : 0,
                info_parent_id : d.CompanyId,
                telephone: d.Phone

              }
            })

          let myArray1 = resCompanies1.filter(
              (el) =>
                !this.companies.some(
                  (data1) => data1.api_company_id == el.company_id
                )
            );

            this.companies = [...this.companies, ...myArray1];

          },
          (error) => {
            this.disableInfoFetchButton = false
            this.snackbar = true
            this.snackbarText = error.data.responseMessage
          });
    },


    fetchCompanies() {
      this.disableFetchButton = true;
      _getCompanies(this.userData)
        .then(
          (response) => {
            let data = response.data.obj.companies;
            this.disableFetchButton = false;

            let resCompanies = data.map(function (d) {
              return {
                company_id: d.id,
                api_company_id: d.id,
                name: d.name,
                label: d.name,
                value: d.name,
                latitude: d.location.latitude,
                longitude: d.location.longitude,
                telephone: d.telephoneNumber
              };
            });
            let myArray = resCompanies.filter(
              (el) =>
                !this.companies.some(
                  (data) => data.api_company_id == el.company_id
                )
            );
            this.companies = [...this.companies, ...myArray];
          },
          (err) => {
            this.disableFetchButton = false;
            this.snackbarText = err.data.responseMessage;
            this.snackbar = true;
          }
        )
        .catch((err) => {
          this.disableFetchButton = false;
          this.snackbarText = err.message;
          this.snackbar = true;
        });
    },
    update() {
      var self = this;
      var itemId = this.editedIndex;
      let objArray = this.companies;
      let sel = this.selectedCompanies;
       this.formErrors= [];
      this.inputErrors= {};
      if(!this.userData.sms_service) {
        alert('Select any sms gateway')
        return;
      }
      var filteredCompanies = [];
      if (objArray) {
        filteredCompanies = objArray.filter((item) => sel.includes(item.name));
      }
      if (filteredCompanies.length) {
        this.userData.companies = filteredCompanies.map((v) => ({
          ...v,
          telephone: v.telephone && v.telephone.startsWith("0") ? v.telephone.slice(1) : (v.telephone || ""),
          judo_account: self.selectedCompaniesJudo.find(
            (item) => item.company === v.name
          ),
        }));
        this.userData.services = this.selectedServices;
        this.userData.allowManual = this.userData.allowManual == "true" ||  this.userData.allowManual == 1 ? 'true' : 'false';
        _update(itemId, this.userData)
          .then(
            (res) => {
              this.$router.push("/users");
            },
            (err) => {
               if (err.data && err.data.status) {
                switch (err.data.status) {
                  case 422:
                    this.inputErrors = err.data.errors // assign field errors
                    this.formErrors = err.data.message
                    return
                  // ... add lots more cases of bad things that can happen here
                }
              }

            }
          )
          .catch((err) => {
            console.log(err.message);
            this.disableFetchButton = false;
            this.snackbar = true;
            this.snackbarText = err.message;
          });
      } else {
        alert("please assigned atleast one company");
      }
    },

    setJudoAccount(company) {

      this.dialog = true;

      var value = this.selectedCompaniesJudo.find(
        (data) => data.company === company
      );
      if (value) {
        this.current_judo = value;
        this.editJudoCredentials = true;
      } else {
        this.editJudoCredentials = false;
        this.current_judo = {
          company: company,
          judo_id: "",
          judo_sandbox_url: "",
          judo_api_version: "",
          judo_auth_sandbox: "",
        };
      }
    },

    saveJudoCredentials() {
      var self = this;
      var value = this.selectedCompaniesJudo.findIndex(
        (data) => data.company === self.current_judo.company
      );
      if (value + 1) {
        self.selectedCompaniesJudo[value] = this.current_judo;
      } else {
        self.selectedCompaniesJudo.push(this.current_judo);
      }
      // if (!this.editJudoCredentials)
      //   this.selectedCompaniesJudo.push(this.current_judo);
      self.dialog = false;
    },

    selectTitleForJudoButton(company) {
      let companyIndex = this.selectedCompaniesJudo.findIndex(
        (item) => item.company === company
      );

      if (companyIndex == -1) return "Add";
      else return "Edit";
    },
    removeJudoCredentials(company) {

      this.selectedCompaniesJudo = this.selectedCompaniesJudo.filter(
        (scj) => scj.company != company
      );
      this.dialog = false;
    },
  },
};
</script>

<style>
.sms-gateway-element-class {
  display: flex;
  justify-content: space-around;
}
.disabled-class {
  display: flex;
  justify-content: space-around;
  color: grey;
}
.space-evenly {
  justify-content: space-evenly;
}
.flex {
  display: flex;
}
.blue-theme {
  color: navy;
  background: white;
}
.bg-red {
  background-color: brown;
}
</style>
